/**
 * @flow
 * @relayHash 54891b5564a70c9ce665bf4cb6219269
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchableContractorDropdownQueryVariables = {|
  contractorName?: ?string
|};
export type SearchableContractorDropdownQueryResponse = {|
  +contractorsByOrg: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
      |}
    |}>,
  |}
|};
export type SearchableContractorDropdownQuery = {|
  variables: SearchableContractorDropdownQueryVariables,
  response: SearchableContractorDropdownQueryResponse,
|};
*/


/*
query SearchableContractorDropdownQuery(
  $contractorName: String
) {
  contractorsByOrg(contractorName: $contractorName, orderBy: "fullName", first: 10, excludeWithConflicts: true, includeInactive: false) {
    edgeCount
    totalCount
    edges {
      node {
        id
        fullName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractorName",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contractorsByOrg",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractorName",
        "variableName": "contractorName"
      },
      {
        "kind": "Literal",
        "name": "excludeWithConflicts",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Literal",
        "name": "includeInactive",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "fullName"
      }
    ],
    "concreteType": "ContractorNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchableContractorDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchableContractorDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SearchableContractorDropdownQuery",
    "id": null,
    "text": "query SearchableContractorDropdownQuery(\n  $contractorName: String\n) {\n  contractorsByOrg(contractorName: $contractorName, orderBy: \"fullName\", first: 10, excludeWithConflicts: true, includeInactive: false) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        fullName\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3d8aaf6da5952958720e2d5eacc2f7f7';
module.exports = node;
